import { useFuelStatistics } from "hooks/use-fuel-statistics";
import { TextStat } from "./text-stat";
import { useTranslation } from "react-i18next";

interface FuelSavingsStatProps {
  labelOnTop?: boolean;
}

export const FuelSavingsStat = ({ labelOnTop }: FuelSavingsStatProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "fuel_curve",
  });

  const { fuelSavings, displayFuelSavings } = useFuelStatistics();

  const label = t("units.liters_per_trip");

  return (
    <TextStat
      label={label}
      value={displayFuelSavings}
      labelOnTop={labelOnTop}
      labelClassName="fill-primary-400"
      valueClassName={
        fuelSavings
          ? fuelSavings >= 0
            ? "fill-green-400"
            : "fill-rose-500"
          : "fill-white"
      }
    />
  );
};
